import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex sm:items-center sm:justify-center min-h-screen sm:px-4 sm:pt-4 sm:pb-20 text-center" }
const _hoisted_2 = { class: "inline-block align-bottom sm:align-middle bg-white dark:bg-gray-800 sm:rounded-lg text-left overflow-hidden shadow-xl transform transition-all min-h-screen w-full fixed inset-x-0 top-0 sm:static sm:min-h-0 sm:max-w-2xl sm:w-full flex flex-col" }
const _hoisted_3 = { class: "bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 px-4 py-4 sm:px-6 flex items-center justify-between flex-shrink-0" }
const _hoisted_4 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_5 = { class: "h-10 w-10 rounded-xl bg-white/20 flex items-center justify-center shrink-0" }
const _hoisted_6 = { class: "min-w-0" }
const _hoisted_7 = { class: "text-lg font-bold text-white truncate" }
const _hoisted_8 = { class: "text-sm text-white/70 truncate" }
const _hoisted_9 = { class: "bg-white dark:bg-gray-800 px-3 pt-4 pb-3 sm:p-6 sm:pb-4 overflow-y-auto flex-1 max-h-[calc(100vh-12rem)]" }
const _hoisted_10 = { class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600 mb-5" }
const _hoisted_11 = { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }
const _hoisted_12 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_13 = { class: "md:col-span-2" }
const _hoisted_14 = { class: "text-sm font-medium text-gray-800 dark:text-gray-200 mt-1" }
const _hoisted_15 = { class: "md:col-span-2" }
const _hoisted_16 = { class: "text-sm font-medium text-gray-800 dark:text-gray-200 mt-1" }
const _hoisted_17 = { class: "text-sm font-medium text-gray-800 dark:text-gray-200 mt-1" }
const _hoisted_18 = {
  key: 0,
  class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600 mb-5"
}
const _hoisted_19 = { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_21 = { class: "mt-1.5" }
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-gray-400 italic"
}
const _hoisted_23 = { class: "mt-1.5" }
const _hoisted_24 = {
  key: 1,
  class: "text-sm text-gray-400 italic"
}
const _hoisted_25 = {
  key: 1,
  class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600 mb-5"
}
const _hoisted_26 = { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "flex items-center justify-center bg-white dark:bg-gray-800 rounded-lg p-2 border border-gray-200 dark:border-gray-600"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "rounded-lg overflow-hidden border border-gray-200 dark:border-gray-600"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 2,
  class: "text-center py-8 text-gray-500 border border-dashed rounded-xl"
}
const _hoisted_33 = {
  key: 1,
  class: "text-sm text-gray-400 italic"
}
const _hoisted_34 = {
  key: 2,
  class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600 mb-5"
}
const _hoisted_35 = { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "flex items-center justify-between gap-3" }
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "text-sm font-medium text-blue-600 dark:text-blue-400 break-all mt-2" }
const _hoisted_40 = {
  key: 1,
  class: "text-sm text-gray-400 italic"
}
const _hoisted_41 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 flex flex-col gap-2 sm:px-6 sm:flex-row-reverse sm:gap-0 shrink-0" }

import {
	FileText, Link2, ExternalLink,
	X, CloudDownload as DownloadIcon,
	BookCopy, ScanEye, Link, FolderOpen
} from 'lucide-vue-next'
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { materialService } from '@/services/material.service'
import type { Material } from '@/config/types/material'
import { useToast } from 'vue-toastification'

const toastTimeout = 5000


export default /*@__PURE__*/_defineComponent({
  __name: 'MaterialDetailsModal',
  props: {
    isOpen: { type: Boolean },
    material: {}
  },
  emits: ["close"],
  setup(__props: any) {

const toast = useToast()
const authStore = useAuthStore()

const isEmployee = computed(() => authStore.currentUser?.role?.toLowerCase() === 'employee')

const props = __props



const typeBadgeClass = (type?: string) => {
  switch (type) {
    case 'Doc File': return 'bg-amber-100 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400'
    case 'Online form': return 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400'
    case 'URL Link': return 'bg-purple-100 text-purple-700 dark:bg-purple-900/20 dark:text-purple-400'
    default: return 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'
  }
}

const isPreviewableImage = (filePath: string) => {
  const ext = filePath.toLowerCase().split('.').pop()
  return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '')
}

const isPreviewablePdf = (filePath: string) => {
  return filePath.toLowerCase().endsWith('.pdf')
}

const handleDownload = async () => {
  if (!props.material?.id) return
  try {
    const token = localStorage.getItem('token')
    const url = materialService.getDownloadUrl(props.material.id)
    const response = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    if (!response.ok) throw new Error('Invalid File')
    const blob = await response.blob()
    const downloadUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = downloadUrl
    a.download = props.material.title || 'download'
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(downloadUrl)
    document.body.removeChild(a)
    toast.success('Document downloaded successfully', { timeout: toastTimeout })
  } catch (err: any) {
    toast.error(err.message || 'Failed to download file', { timeout: toastTimeout })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Globe = _resolveComponent("Globe")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-50 overflow-y-auto",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity bg-black bg-opacity-50 dark:bg-opacity-50",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (__props.material?.type === 'URL Link')
                        ? (_openBlock(), _createBlock(_unref(Link2), {
                            key: 0,
                            class: "h-5 w-5 text-white"
                          }))
                        : (__props.material?.type === 'Doc File')
                          ? (_openBlock(), _createBlock(_unref(FileText), {
                              key: 1,
                              class: "h-5 w-5 text-white"
                            }))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", _hoisted_7, _toDisplayString(__props.material?.title || 'Material Details'), 1),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(__props.material?.type), 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                    class: "shrink-0 p-1.5 rounded-lg hover:bg-white/10 text-white/80 hover:text-white transition-colors"
                  }, [
                    _createVNode(_unref(X), { class: "h-5 w-5" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h4", _hoisted_11, [
                      _createVNode(_unref(BookCopy), { class: "h-4 w-4 inline" }),
                      _cache[4] || (_cache[4] = _createTextVNode(" Basic Information ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "Title", -1)),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(__props.material?.title || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "Description", -1)),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(__props.material?.description || 'No description'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "Type", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["inline-flex items-center gap-1 mt-1 px-2.5 py-1 text-xs font-medium rounded-lg", typeBadgeClass(__props.material?.type)])
                        }, [
                          (__props.material?.type === 'Doc File')
                            ? (_openBlock(), _createBlock(_unref(FileText), {
                                key: 0,
                                class: "h-5 w-4"
                              }))
                            : (__props.material?.type === 'Online form')
                              ? (_openBlock(), _createBlock(_component_Globe, {
                                  key: 1,
                                  class: "h-4 w-4"
                                }))
                              : (__props.material?.type === 'URL Link')
                                ? (_openBlock(), _createBlock(_unref(Link2), {
                                    key: 2,
                                    class: "h-4 w-4"
                                  }))
                                : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(__props.material?.type || '—'), 1)
                        ], 2)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "Status", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["inline-flex items-center mt-1.5 px-2.5 py-0.5 text-xs font-semibold rounded-full", __props.material?.status === 'active' ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'])
                        }, _toDisplayString(__props.material?.status === 'active' ? 'Active' : 'Inactive'), 3)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "Date Added", -1)),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(__props.material?.created_at ? new Date(__props.material.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : '—'), 1)
                      ])
                    ])
                  ]),
                  (!isEmployee.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("h4", _hoisted_19, [
                          _createVNode(_unref(ScanEye), { class: "h-4 w-4 inline" }),
                          _cache[10] || (_cache[10] = _createTextVNode(" Viewers & Access ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", null, [
                            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "By Position", -1)),
                            _createElementVNode("div", _hoisted_21, [
                              (__props.material?.position_viewers && __props.material.position_viewers.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.material.position_viewers, (v) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: 'pos-'+v.id,
                                      class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-primary/10 dark:bg-primary-dark/10 text-primary dark:text-primary-dark mr-1.5 mb-1.5"
                                    }, _toDisplayString(v.name), 1))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("p", _hoisted_22, "None"))
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "By Employee", -1)),
                            _createElementVNode("div", _hoisted_23, [
                              (__props.material?.user_viewers && __props.material.user_viewers.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.material.user_viewers, (v) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: 'usr-'+v.id,
                                      class: "inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-primary/10 dark:bg-primary-dark/10 text-primary dark:text-primary-dark mr-1.5 mb-1.5"
                                    }, _toDisplayString(v.first_name ? v.first_name + ' ' + v.last_name : v.username), 1))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("p", _hoisted_24, "None"))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (__props.material?.type === 'Doc File')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("h4", _hoisted_26, [
                          _createVNode(_unref(FolderOpen), { class: "h-4 w-4 inline" }),
                          _cache[13] || (_cache[13] = _createTextVNode(" File Preview ", -1))
                        ]),
                        (__props.material?.file_path)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (isPreviewableImage(__props.material.file_path))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("img", {
                                      src: _unref(materialService).getFileUrl(__props.material.file_path),
                                      alt: "file preview",
                                      class: "max-w-full max-h-[50vh] rounded object-contain"
                                    }, null, 8, _hoisted_29)
                                  ]))
                                : (isPreviewablePdf(__props.material.file_path))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("iframe", {
                                        src: _unref(materialService).getFileUrl(__props.material.file_path),
                                        class: "w-full h-[50vh]"
                                      }, null, 8, _hoisted_31)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createVNode(_unref(FileText), { class: "h-12 w-12 mx-auto mb-2 text-gray-300 dark:text-gray-600" }),
                                      _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-base font-medium" }, "Preview not available", -1)),
                                      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm mt-1" }, "This file type cannot be previewed in the browser.", -1))
                                    ]))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_33, "No file attached."))
                      ]))
                    : (__props.material?.type === 'URL Link' || __props.material?.type === 'Online form')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("h4", _hoisted_35, [
                            _createVNode(_unref(Link), { class: "h-4 w-4 inline" }),
                            _cache[16] || (_cache[16] = _createTextVNode(" Link ", -1))
                          ]),
                          (__props.material?.url_link)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide" }, "URL", -1)),
                                  _createElementVNode("a", {
                                    href: __props.material.url_link,
                                    target: "_blank",
                                    class: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold text-white bg-primary hover:bg-secondary shadow-sm transition-all shrink-0"
                                  }, [
                                    _cache[17] || (_cache[17] = _createTextVNode(" Open ", -1)),
                                    _createVNode(_unref(ExternalLink), { class: "h-3.5 w-3.5" })
                                  ], 8, _hoisted_38)
                                ]),
                                _createElementVNode("p", _hoisted_39, _toDisplayString(__props.material.url_link), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_40, "No link provided."))
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  (__props.material?.type === 'Doc File' && __props.material?.file_path)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: handleDownload,
                        class: "w-full sm:w-auto sm:ml-3 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 shadow-sm transition-all inline-flex items-center justify-center gap-2"
                      }, [
                        _createVNode(_unref(DownloadIcon), { class: "h-4 w-4" }),
                        _cache[19] || (_cache[19] = _createTextVNode(" Download ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-secondary-text dark:text-secondary-dark-text hover:bg-gray-100/80 dark:hover:bg-gray-700/60 transition-colors",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                  }, " Close ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})